export default {
  httpApi: ['https://www.lifeapp.com'],
  websocket: {
    url: 'wss://www.lifeapp.com:8081/sockjs',
    api: 'https://www.lifeapp.com',
    pingInterval: 50 * 1000,
    maxPingInterval: 2 * 60 * 1000,
    maxWaitingForcePing: 5 * 1000
  },
  logger: {
    api: true,
    events: true,
    model: true,
    component: true,
    debug: true,
    warn: true,
    state: false,
    websocket: true
  }
};
